module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAHCAYAAADam2dgAAAAAXNSR0IArs4c6QAAAI5JREFUGBljlO/+d5nh/38dBhyAkYHxMhPj//+ncMiDhf8z/D/JJMzPlMvAyHgNu0LGqyL8TPmMIEmVnv9av//9P83A8J8LrpiR8SsDC6Ppw0LG60wgwTsljNcYmRiz4AqADKb/jFkgBchiYLZCz9/58l1//yt0/52HLMmCzBHmZcp+94nhmAQzw5IHSBIAxUoqGoOhjNcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/search/dropdown.png
// module id = K11q
// module chunks = 2